import { render, staticRenderFns } from "./AddCityComponent.vue?vue&type=template&id=6824cac3&"
import script from "./AddCityComponent.vue?vue&type=script&lang=js&"
export * from "./AddCityComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports